import { AlliancesList } from '@/components/alliances';
import { useEventContext } from '@/pages/events/useEventContext';
import { Skeleton } from '@startupquickstart/frontend';

/**
 * Alliances tab for the event detail page
 */
export function EventAlliancesTab() {
  const { event, isLoading } = useEventContext();

  if (isLoading) {
    return (
      <div className="space-y-6">
        <Skeleton className="h-48 rounded-xl" />
      </div>
    );
  }

  if (!event) {
    return (
      <div className="text-center py-12">
        <p className="text-muted-foreground">Event not found</p>
      </div>
    );
  }

  return (
    <div className="flex-1 min-h-0 overflow-auto -m-4 sm:-m-6 p-4 sm:p-6 space-y-6">
      <AlliancesList eventId={event.id} />
    </div>
  );
}
